import React from 'react';
import PropTypes from 'prop-types';

import styles from './PricingGrid.scss';

import Button from 'Components/Button';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import ContactLink from 'Components/ContactLink';

const PricingOptionButton = props => {
  const { id, type, selected, upgrading, buttonType } = props;

  if (id === 'custom')
    return (
      <ContactLink
        type="button"
        prefill={{ subject: 'Custom pricing inquiry' }}
      />
    );

  const getLabelId = () => {
    if (id === 'custom') return 'custom_button_cta';
    if (selected && type === 'payment') return 'button_selected_cta';
    if (type === 'payment') return 'button_change_plan_cta';
    if (upgrading) return 'button_purchase_cta';
    return 'button_cta';
  };

  const buttonProps = {
    label: <ConnectedFormattedMessage id={`pricing_plan.${getLabelId()}`} />,
    additionalClasses: ' PricingOption__button',
    buttonType: `primary${
      selected && type === 'payment' ? '-transparent' : ''
    }`,
  };
  if (buttonType) buttonProps.buttonType = buttonType;
  if (props.route) buttonProps.route = props.route;
  if (props.clickHandler)
    buttonProps.clickHandler = () => props.clickHandler(id);
  const label = (
    <ConnectedFormattedMessage id={`pricing_plan.${getLabelId()}`} />
  );
  return <Button {...buttonProps} />;
};

export default PricingOptionButton;
